import React from 'react'

// Controlled by the grid's layout so the switch reads right when the page
// starts in list view (the default everywhere).
const ViewSwitcher = ({ layout, switchLayout }) => {

	const active = layout === 'list'

	return (
	<button className={active ? 'toggle-btn on' : 'toggle-btn off'} onClick={(e) => switchLayout( e, active ? 'grid' : 'list' )}>
		<span className="pin" />
	</button>
	)
}

  export default ViewSwitcher
